import { Box, Flex, Text } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import classNames from "classnames/dedupe";
import { useAtom } from "jotai";
import { useCallback } from "react";
import type { RatingsProps } from ".";
import { creditRatingAgencyDescriptions } from "../../../../constants/constants";
import { sliderStateAtom } from "../../../../store";
import { InfoModal } from "../InfoModal";

export const Ratings = ({ data }: RatingsProps) => {
  const { snowplow } = useSnowplowContext();
  const { reinsurerText, ratingBody, ratingType, rating } = data;
  const ratingAgency = creditRatingAgencyDescriptions[ratingType];
  const blankSpace = <>&nbsp;</>;
  const containerClasses = classNames("mobius-quote-card__ratings", {
    "--has-reinsurer-text": reinsurerText,
  });

  const [sliderIsOpen] = useAtom(sliderStateAtom);

  const handleOpen = useCallback(() => {
    const category = `${
      sliderIsOpen ? "quote_details_slider" : "qcp"
    }_insurer_rating_help`;

    if (ratingAgency) {
      snowplow?.trigger("ratingsModalOpened", {
        category,
        label: ratingAgency.label,
      });
    }
  }, [ratingAgency, sliderIsOpen, snowplow]);

  return (
    <Flex
      flexDirection="column"
      className={containerClasses}
      data-testid="ratings-control"
    >
      <Text
        className="mobius-quote-card__ratings-text"
        data-testid="ratings-text"
      >
        {reinsurerText || blankSpace}
      </Text>
      {(ratingBody || rating) && (
        <Box className="mobius-quote-card__ratings-body">
          {ratingAgency && (
            <InfoModal
              toggleText={ratingBody || ""}
              title={ratingAgency.label}
              body={ratingAgency.description}
              onOpen={handleOpen}
            />
          )}
          {rating && (
            <Text variant="small" className="mobius-quote-card__ratings-value">
              {rating}
            </Text>
          )}
        </Box>
      )}
    </Flex>
  );
};
